 //jes custom code

if(localStorage.build_bundle_b == 'true'){
  document.querySelector('.bundle-build-contents-wraper').classList.add('style-b')
}
async function renderProductjs(slug,option,position){
  if(position == 1){
      document.querySelector('.bundle-products-wraper').classList.remove('loading-false');
      document.querySelector('.bundle-products-wraper').classList.add('loading-content');
  }        
  var pd_url = window.location.origin+"/collections/"+slug+"?view=build-bundle";
  var bundle_pro = document.querySelector('.bundle-build-contents-wraper').getAttribute('data-bundle-type');
  const response = await fetch(pd_url);        
  const element = document.createElement("div");   
  element.innerHTML = await response.text();
  element.innerHTML = element.innerHTML.replaceAll('data-bundle-type=""','data-bundle-type="'+bundle_pro+'"');
  element.querySelectorAll('li.productgrid--item[data-available="false"]').forEach((ele)=>{
      ele.remove();
  })  
  var item_num = element.querySelectorAll('ul.productgrid--items li.productgrid--item').length;
  if(item_num == 0){            
      document.querySelector('.bundle-products-wraper').classList.remove('loading-content');
      document.querySelector('.bundle-products-wraper').classList.add('loading-false');
      return false;
  }
  if(item_num  < 2){
      document.querySelector('.bundle-products-wraper .item-wraper-'+position+' .prev-next-button--next').setAttribute('disabled','')
  }else{
      document.querySelector('.bundle-products-wraper .item-wraper-'+position+' .prev-next-button--next').removeAttribute('disabled');
  }
  document.querySelector('.rendered-items-'+ position).innerHTML = element.querySelector('ul.productgrid--items').innerHTML.replaceAll('value="Bundle section url"','value="('+window.location.pathname+')"');
  document.querySelector('.reload-bundle').setAttribute('data-item-'+ position, item_num);        
  //var item_index = Math.floor(Math.random() * item_num ) + 1;        
  //var item = element.querySelector('ul.productgrid--items li.productgrid--item:nth-child('+item_index+')');
  var item = element.querySelector('ul.productgrid--items li.productgrid--item:nth-child(1)');
  document.querySelector('.bundle-products-wraper .item-wraper-'+position+' .pd-item-wraper').innerHTML = item.outerHTML;
  //var new_variant_option = "";        
  //item.querySelectorAll('quick-buy-second .variant-options .variant-option[available="true"]').forEach((ele)=>{
  //    var value = ele.innerText.trim();
  //    new_variant_option = new_variant_option+`<li class="linklist__item custom-links popover__choice-item">
  //        <span class="link--faded">
  //            <span data-size="${value}">${value}</span>
  //        </span>
  //    </li>` ;
  //})
  //document.querySelector(".size"+position+"-dropdown-container ul").innerHTML = new_variant_option;
  //var selected_option = document.querySelector(".size"+position+"-dropdown-container ul li span.link--faded").innerHTML; 
  //document.querySelector('.size'+position+'-dropdown-container button.select span.link--faded').innerHTML = selected_option;
  //bundleVariantSelect(position);
  if(position == 3){
      document.querySelector('.bundle-products-wraper').classList.remove('loading-false');
      document.querySelector('.bundle-products-wraper').classList.remove('loading-content');
      document.querySelector('.bundle-products-wraper').classList.remove('loading-content-initial');
      document.querySelectorAll('.bundle-products-wraper .custom-checkbox').forEach((ele)=>{
        ele.addEventListener('click', function(){
          var i_position = ele.closest('.product-item-wraper').querySelector('button').getAttribute('data-position');
          var i_index = ele.closest('.product-item-wraper').querySelector('button').getAttribute('item-index');
          ele.closest('.productitem').classList.toggle('checked');
          document.querySelector('.rendered-items-'+i_position+' li:nth-child('+i_index+') .productitem').classList.toggle('checked');
  
          var checked_total_length = document.querySelectorAll('.rendered-items-wraper .productitem.checked').length;
          if(checked_total_length == 0 ){
             this.closest('.bundle-build-contents-wraper').querySelector('.bundle-total .bundle-total-note').innerHTML = "Please Select Item.";
             this.closest('.bundle-build-contents-wraper').querySelector('.bundle-total .bundle-original').innerHTML = ""; 
             this.closest('.bundle-build-contents-wraper').querySelector('.bundle-total .bundle-sale').innerHTML = ""; 
             this.closest('.bundle-build-contents-wraper').querySelector('.bundle-sale-percent').innerHTML = ""; 
             this.closest('.bundle-build-contents-wraper').querySelector('.add-cart-bundle').setAttribute('disabled','');
           }else{
             this.closest('.bundle-build-contents-wraper').querySelector('.bundle-total .bundle-total-note').innerHTML = "Total: ";
             this.closest('.bundle-build-contents-wraper').querySelector('.add-cart-bundle').removeAttribute('disabled');
             var bundle_total = 0;
             document.querySelectorAll('.rendered-items-wraper .productitem.checked .productitem--actions .price__current.price__current--emphasize>.money').forEach((ele)=>{
               bundle_total += ele.getAttribute('item-price')*1;           
             });
             this.closest('.bundle-build-contents-wraper').querySelector('.bundle-total .bundle-original').innerHTML = "$ " + bundle_total.toFixed(2);
             // if(checked_total_length == 1){
             //   this.closest('.bundle-build-contents-wraper').querySelector('.bundle-total .bundle-sale').innerHTML = "$ " + (bundle_total*0.95).toFixed(2);
             //   this.closest('.bundle-build-contents-wraper').querySelector('.bundle-sale-percent').innerHTML = "Saving 5%"; 
             // }else if(checked_total_length == 2){
             //   this.closest('.bundle-build-contents-wraper').querySelector('.bundle-total .bundle-sale').innerHTML = "$ " + (bundle_total*0.90).toFixed(2);
             //   this.closest('.bundle-build-contents-wraper').querySelector('.bundle-sale-percent').innerHTML = "Saving 10%"; 
             // }else{
             //   this.closest('.bundle-build-contents-wraper').querySelector('.bundle-total .bundle-sale').innerHTML = "$ " + (bundle_total*0.82).toFixed(2);
             //   this.closest('.bundle-build-contents-wraper').querySelector('.bundle-sale-percent').innerHTML = "Saving 18%"; 
             // }
           } 
        })
      })
  }
  return true;       
}

function slideItem(position,index,direction){
  var item_num = 1;
  if(direction=="next"){
      item_num = index+1;
      if(item_num>1){
          document.querySelector('.bundle-products-wraper .item-wraper-'+position+' .prev-next-button--prev').removeAttribute('disabled');
      }
      if(item_num == document.querySelectorAll(".rendered-items-"+position+" li.productgrid--item").length) {
          document.querySelector('.bundle-products-wraper .item-wraper-'+position+' .prev-next-button--next').setAttribute('disabled','');
      }           
  }else if(direction=='prev'){
      item_num = index-1;
      if(item_num < document.querySelectorAll(".rendered-items-"+position+" li.productgrid--item").length){
          document.querySelector('.bundle-products-wraper .item-wraper-'+position+' .prev-next-button--next').removeAttribute('disabled');
      }
      if(item_num == 1 ) {
          document.querySelector('.bundle-products-wraper .item-wraper-'+position+' .prev-next-button--prev').setAttribute('disabled','');
      }      
  }   
  document.querySelector('.bundle-products-wraper .item-wraper-'+position+' .prev-next-button--next').setAttribute('item-index',item_num);
  document.querySelector('.bundle-products-wraper .item-wraper-'+position+' .prev-next-button--prev').setAttribute('item-index',item_num);     
  var item = document.querySelector('.rendered-items-'+ position + ' li.productgrid--item:nth-child('+item_num+')');
  document.querySelector('.bundle-products-wraper .item-wraper-'+position+' .pd-item-wraper').innerHTML = item.outerHTML;
  document.querySelectorAll('.item-wraper-'+position+' .custom-checkbox').forEach((ele)=>{
    ele.addEventListener('click', function(){    
      var i_position = ele.closest('.product-item-wraper').querySelector('button').getAttribute('data-position');
      var i_index = ele.closest('.product-item-wraper').querySelector('button').getAttribute('item-index');
      ele.closest('.productitem').classList.toggle('checked');
      document.querySelector('.rendered-items-'+i_position+' li:nth-child('+i_index+') .productitem').classList.toggle('checked');
      
      var checked_total_length = document.querySelectorAll('.rendered-items-wraper .productitem.checked').length;
      if(checked_total_length == 0 ){
         this.closest('.bundle-build-contents-wraper').querySelector('.bundle-total .bundle-total-note').innerHTML = "Please Select Item.";
         this.closest('.bundle-build-contents-wraper').querySelector('.bundle-total .bundle-original').innerHTML = ""; 
         this.closest('.bundle-build-contents-wraper').querySelector('.bundle-total .bundle-sale').innerHTML = ""; 
         this.closest('.bundle-build-contents-wraper').querySelector('.bundle-sale-percent').innerHTML = ""; 
         this.closest('.bundle-build-contents-wraper').querySelector('.add-cart-bundle').setAttribute('disabled','');
       }else{
         this.closest('.bundle-build-contents-wraper').querySelector('.bundle-total .bundle-total-note').innerHTML = "Total: ";
         this.closest('.bundle-build-contents-wraper').querySelector('.add-cart-bundle').removeAttribute('disabled');
         var bundle_total = 0;
         document.querySelectorAll('.rendered-items-wraper .productitem.checked .productitem--actions .price__current.price__current--emphasize>.money').forEach((ele)=>{
           bundle_total += ele.getAttribute('item-price')*1;           
         });
         this.closest('.bundle-build-contents-wraper').querySelector('.bundle-total .bundle-original').innerHTML = "$ " + bundle_total.toFixed(2);
         // if(checked_total_length == 1){
         //   this.closest('.bundle-build-contents-wraper').querySelector('.bundle-total .bundle-sale').innerHTML = "$ " + (bundle_total*0.95).toFixed(2);
         //   this.closest('.bundle-build-contents-wraper').querySelector('.bundle-sale-percent').innerHTML = "Saving 5%"; 
         // }else if(checked_total_length == 2){
         //   this.closest('.bundle-build-contents-wraper').querySelector('.bundle-total .bundle-sale').innerHTML = "$ " + (bundle_total*0.90).toFixed(2);
         //   this.closest('.bundle-build-contents-wraper').querySelector('.bundle-sale-percent').innerHTML = "Saving 10%"; 
         // }else{
         //   this.closest('.bundle-build-contents-wraper').querySelector('.bundle-total .bundle-sale').innerHTML = "$ " + (bundle_total*0.82).toFixed(2);
         //   this.closest('.bundle-build-contents-wraper').querySelector('.bundle-sale-percent').innerHTML = "Saving 18%"; 
         // }
       } 
    })
  })
  //var new_variant_option = "";        
  // item.querySelectorAll('quick-buy-second .variant-options .variant-option[available="true"]').forEach((ele)=>{
  //     var value = ele.innerText.trim();
  //     new_variant_option = new_variant_option+`<li class="linklist__item custom-links popover__choice-item">
  //         <span class="link--faded">
  //             <span data-size="${value}">${value}</span>
  //         </span>
  //     </li>` ;
  // })
  // document.querySelector(".size"+position+"-dropdown-container ul").innerHTML = new_variant_option;
  // var selected_option = document.querySelector(".size"+position+"-dropdown-container ul li span.link--faded").innerHTML; 
  // document.querySelector('.size'+position+'-dropdown-container button.select span.link--faded').innerHTML = selected_option;
  // bundleVariantSelect(position);
}

document.querySelectorAll(".bundle-products-wraper .prev-next-button").forEach((ele)=>{
  ele.addEventListener('click',function(){
      if(!this.hasAttribute('disabled')){                
          let index = this.getAttribute('item-index')*1;
          let position = this.getAttribute('data-position')*1;
          let direction = this.getAttribute('data-direction');
          slideItem(position,index,direction);
      }
  })
})

document.querySelectorAll(".team-dropdown-container .popover__choice-item").forEach((item)=>{
  item.addEventListener('click', function(){
      var team = this.querySelector('img').getAttribute('alt');
      if(document.querySelector('.team-dropdown-container button.select img').getAttribute('alt') == team){
          document.querySelector('.team-dropdown-container button.select').click();
          return false;
      } 
      var selected_item = this.querySelector('span.link--faded').innerHTML; 
      document.querySelector('.team-dropdown-container button.select span.link--faded').innerHTML = selected_item;            
      document.querySelector('.team-dropdown-container button[aria-expanded="true"]')?.click();
      var slug = team.toLowerCase().replaceAll(' ','-');
      var option_1 = document.querySelector('.option1-dropdown-container .link--faded span').getAttribute('data-option');
      var option_2 = document.querySelector('.option2-dropdown-container .link--faded span').getAttribute('data-option');
      if(renderProductjs(slug,option_1,1)){
          renderProductjs(slug,option_2,2)
      }
          
  })
  })
document.querySelectorAll(".league-dropdown-container .popover__choice-item").forEach((item)=>{
  item.addEventListener('click', function(){
      var league = this.getAttribute('data-league');
      document.querySelector('.bundle-build-contents-wraper').setAttribute('data-league',league);
      if(league == 'nhl'){
          document.querySelector('.option2-dropdown-container>button .link--faded span').setAttribute('data-option',"Headwear");
          document.querySelector('.option2-dropdown-container>button .link--faded span').innerHTML="Headwear";
      }else{
          document.querySelector('.option2-dropdown-container>button .link--faded span').setAttribute('data-option',"Joggers");
          document.querySelector('.option2-dropdown-container>button .link--faded span').innerHTML="Jogger";
      }
      if(document.querySelector('.league-dropdown-container button.select img').getAttribute('alt') == league){
          document.querySelector('.league-dropdown-container button.select').click();
          return false;
      } 
      var selected_item = this.querySelector('span.link--faded').innerHTML;        
      document.querySelector('.team-dropdown-container ul.popover__choice-list.active').classList.remove('active');
      document.querySelector('.team-dropdown-container ul.popover__choice-list.'+league).classList.add('active');
      document.querySelector('.league-dropdown-container button.select span.link--faded').innerHTML = selected_item;
      document.querySelector('.team-dropdown-container ul.popover__choice-list.'+league+' li:first-child').click();
      document.querySelector('.league-dropdown-container button.select').click();
  })
})
document.querySelectorAll(".option1-dropdown-container .popover__choice-item").forEach((item)=>{
  item.addEventListener('click', function(){
      var option = this.querySelector('.link--faded>span').getAttribute('data-option');
      if(document.querySelector('.option1-dropdown-container button.select .link--faded>span').getAttribute('data-option') == option){
          document.querySelector('.option1-dropdown-container button.select').click();
          return false;
      } 
      var selected_item = this.querySelector('span.link--faded').innerHTML; 
      document.querySelector('.option1-dropdown-container button.select span.link--faded').innerHTML = selected_item;            
      document.querySelector('.option1-dropdown-container button[aria-expanded="true"]')?.click();
      var slug = document.querySelector('.team-dropdown-container button img').getAttribute('alt').toLowerCase().replaceAll(' ','-');
      var option_1 = document.querySelector('.option1-dropdown-container .link--faded span').getAttribute('data-option');
      var option_2 = document.querySelector('.option2-dropdown-container .link--faded span').getAttribute('data-option');
      if(renderProductjs(slug,option_1,1)){
          renderProductjs(slug,option_2,2)
      }            
  })
  })    
document.querySelectorAll(".option2-dropdown-container .popover__choice-item").forEach((item)=>{
  item.addEventListener('click', function(){
      var option = this.querySelector('.link--faded>span').getAttribute('data-option');
      if(document.querySelector('.option2-dropdown-container button.select .link--faded>span').getAttribute('data-option') == option){
          document.querySelector('.option2-dropdown-container button.select').click();
          return false;
      } 
      var selected_item = this.querySelector('span.link--faded').innerHTML; 
      document.querySelector('.option2-dropdown-container button.select span.link--faded').innerHTML = selected_item;            
      document.querySelector('.option2-dropdown-container button[aria-expanded="true"]')?.click();
      var slug = document.querySelector('.team-dropdown-container button img').getAttribute('alt').toLowerCase().replaceAll(' ','-');
      var option_1 = document.querySelector('.option1-dropdown-container .link--faded span').getAttribute('data-option');
      var option_2 = document.querySelector('.option2-dropdown-container .link--faded span').getAttribute('data-option');
      if(renderProductjs(slug,option_1,1)){
          renderProductjs(slug,option_2,2)
      }
  })
  })  
function bundleVariantSelect(position){    
  document.querySelectorAll(".size"+position+"-dropdown-container .popover__choice-item").forEach((item)=>{
      item.addEventListener('click', function(){
          var option = this.querySelector('.link--faded>span').getAttribute('data-size');
          if(document.querySelector('.size'+position+'-dropdown-container button.select .link--faded>span').getAttribute('data-size') == option){
              document.querySelector('.size'+position+'-dropdown-container button.select').click();
              return false;
          } 
          var selected_item = this.querySelector('span.link--faded').innerHTML; 
          document.querySelector('.size'+position+'-dropdown-container button.select span.link--faded').innerHTML = selected_item;            
          document.querySelector('.size'+position+'-dropdown-container button[aria-expanded="true"]')?.click();
      })
  }) 
}  
//bundleVariantSelect(1);bundleVariantSelect(2);
document.querySelectorAll(".add-cart-bundle").forEach((item)=>{
  item.addEventListener('click', function(){
      this.setAttribute('aria-busy',true);
      var section = this.closest('.build-bundle-section');
      // var index_1 = section.querySelector('.item-wraper-1 button.product-list__arrow').getAttribute('item-index')*1;
      // var index_2 = section.querySelector('.item-wraper-2 button.product-list__arrow').getAttribute('item-index')*1;
      // var index_3 = section.querySelector('.item-wraper-3 button.product-list__arrow').getAttribute('item-index')*1;
      // //var size1 = section.querySelector('.size1-dropdown-container button.select .link--faded>span').getAttribute('data-size');
      // //var size2 = section.querySelector('.size2-dropdown-container button.select .link--faded>span').getAttribute('data-size');
      // //section.querySelector('.bundle-products-wraper .item-wraper-1 .pd-item-wraper quick-buy-second .variant-options li[variant-title="'+size1+'"]').click();
      // section.querySelector('.rendered-items-1 .productgrid--item:nth-child('+index_1+') .productitem--action-atc').click();
      // setTimeout(function(){
      //     section.querySelector('.rendered-items-2 .productgrid--item:nth-child('+index_2+') .productitem--action-atc').click(); 
      // },1000);
      // setTimeout(function(){
      //   section.querySelector('.rendered-items-3 .productgrid--item:nth-child('+index_3+') .productitem--action-atc').click(); 
      // },2000)  
      // setTimeout(function(){
      //     section.querySelector('button.add-cart-bundle').setAttribute('aria-busy',false);
      // },4000);
      var checked_total_length = document.querySelectorAll('.rendered-items-wraper .productitem.checked').length;
      // document.querySelectorAll('.rendered-items-wraper input[name="properties[bundle]"]').forEach((item)=>{
      //   item.value = '';     
      // })
      var loop = 0;
      document.querySelectorAll('.rendered-items-wraper .productitem.checked').forEach((item)=>{
        // if(checked_total_length==1){
        //   item.closest('.quick-shop-style--inline').querySelector('.inline-quickshop input[name="properties[bundle]"]').value = '5%';        
        // }else if(checked_total_length==2){
        //   item.closest('.quick-shop-style--inline').querySelector('.inline-quickshop input[name="properties[bundle]"]').value = '10%';        
        // }else{
        //   item.closest('.quick-shop-style--inline').querySelector('.inline-quickshop input[name="properties[bundle]"]').value = '18%';        
        // }
        loop++;
        var time_out = loop *800;
        setTimeout(function(){
          item.querySelector('.productitem--action-atc').click();
        },time_out);      
      })
  })
})  
document.querySelector('.reload-bundle').addEventListener('click', function(){
  var slug = "bundle-collection";
  var slug2 = "bundle-collection";
  var slug3 = "bundle-collection";
  //var slug = document.querySelector('.team-dropdown-container button img').getAttribute('alt').toLowerCase().replaceAll(' ','-');
  //var option_1 = document.querySelector('.option1-dropdown-container .link--faded span').getAttribute('data-option');
  //var option_2 = document.querySelector('.option2-dropdown-container .link--faded span').getAttribute('data-option');
  if(renderProductjs(slug,'',1)){
      if(renderProductjs(slug2,'',2)){
        renderProductjs(slug3,'',3)
      }
  }
})
document.querySelector('.reload-bundle').click();
